import React, { useEffect, useState } from 'react'
import notify from '../../utils/Notification';
import MapProductGrid from './MapProductGrid';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { createB2BAPI } from '../../api/Interceptor';
import Navigation from '../../components/customer/sidebar/Navigation';
import { useMediaQuery, useDebouncedValue } from '@mantine/hooks';

import { useLoader } from '../../Context/LoaderContext';

const VendorProducts = () => {
    const location = useLocation();
    const isMobile = useMediaQuery("(max-width: 767px)");
    const isTablet = useMediaQuery("(min-width: 768px) and (max-width: 991px)");
    const navigate = useNavigate();
    const B2B_API = createB2BAPI();
    const { showLoader, hideLoader } = useLoader();
    const responseData = location?.state?.tabinfo;
    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 5 });

    const userId = JSON.parse(localStorage.getItem('user'))?.userId;

    const [mappedProduct, setMappedProduct] = useState(0);
    const [mappedPageCount, setMappedPageCount] = useState(0);
    const [status, setStatus] = useState('published');
    const [isCreateProduct, setIsCreateProduct] = useState(false);
    const [unMappedRowCount, setUnMappedRowCount] = useState(0);
    const [mappedRowCount, setMappedRowCount] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearch] = useDebouncedValue(searchTerm, 500);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    useEffect(() => {
        fetchAllMappedProducts();
    }, [pagination.pageIndex, pagination.pageSize, debouncedSearch]);
    const handleSearchChange = (event) => {
        setSearchTerm(event);
        setPagination(prev => ({ ...prev, pageIndex: 0 }));
    };
    const editVarientForMapped = (varobj, map) => {
        setIsCreateProduct(true);
        navigate(`/draftMappedProduct?id=${varobj}&map=${map}&page=${pagination.pageIndex}&size=${pagination.pageSize}&search=${searchTerm}`, { state: { productId: varobj, map: map } });
    };

    const fetchAllMappedProducts = async () => {

        try {
            setIsLoading(true);
            showLoader();
            const response = await B2B_API.get(`product/mappedProducts/search?vendorId=${userId}&page=${pagination.pageIndex}&size=${pagination.pageSize}&searchTerm=${debouncedSearch}`).json();
            const data = response?.response?.content || [];
            setMappedRowCount(response?.response?.totalElements || 0);
            setMappedProduct(data);
        } catch (error) {
            setIsError(true);
            notify({
                id: "fetch_products",
                error: true,
                success: false,
                title: error?.message || ERROR_MESSAGE
            });
        } finally {
            setIsLoading(false);
            hideLoader();
        }
    };
    return (
        <div className="view-my-page router-view-container">
            <div className="route-view">
                {!isMobile && !isTablet && <Navigation />}
                <MapProductGrid
                    isLoading={isLoading}
                    vendorId={userId}
                    isError={isError}
                    data={mappedProduct}
                    editVarientForMapped={editVarientForMapped}
                    onPaginationChange={setPagination}
                    pagination={pagination}
                    pageCount={mappedPageCount}
                    rowCount={mappedRowCount}
                    manualPagination={true}
                    searchTerm={searchTerm}
                    handleSearchChange={handleSearchChange}
                    status={status}
                    map={true}
                    setStatus={setStatus}
                />
            </div>
        </div>
    )
}

export default VendorProducts
